import UserCrudTableRow from "./UserCrudTableRow";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import Pagination from "components/Pagination";

const UserCrudTable = ({
                           pagedData,
                           handlePageClick,
                           forcePage,
                           setDataToEditAndShowModal,
                           setDataToUpdatePassAndShowModal,
                           setDataToUpdateAbilitiesAndShowModal,
                           deleteData
                       }) => {
    let users = pagedData.docs;
    let myAbilities = HelpAbility();


    return (
        <>
            <div className="table-responsive" style={{marginTop: '.25rem'}}>
                <table className="table table-bordered table-striped table-sm">
                    <thead>
                    <tr>
                        <th scope="col" className="text-center">Nombres</th>
                        <th scope="col" className="text-center">Apellido Paterno</th>
                        <th scope="col" className="text-center">Apellido Materno</th>
                        <th scope="col" className="text-center">Correo Electrónico</th>
                        <th scope="col" className="text-center">Rol</th>
                        {myAbilities.hasAny([C.A.USER.UPDATE, C.A.USER.UPDATE_PASS, C.A.USER.UPDATE_ABIL, C.A.USER.DELETE]) &&
                        <th scope="col" className="text-center">Acción</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        users.length > 0 ? users.map((user, i) =>
                                <UserCrudTableRow key={user._id} user={user}
                                                  setDataToEditAndShowModal={setDataToEditAndShowModal}
                                                  setDataToUpdatePassAndShowModal={setDataToUpdatePassAndShowModal}
                                                  setDataToUpdateAbilitiesAndShowModal={setDataToUpdateAbilitiesAndShowModal}
                                                  deleteData={deleteData}
                                />) :
                            <tr>
                                <th scope="row" colSpan="5" className="text-center">Sin datos</th>
                            </tr>
                    }
                    </tbody>
                </table>
            </div>
            <Pagination pagedData={pagedData} onPageChange={handlePageClick} forcePage={forcePage}/>
        </>
    );
}
export default UserCrudTable;
